module.exports = __webpack_public_path__ + "assets/media/csv-import-icon.ba731e82.svg";